import React from "react";

function DocStats({ stats, isLoading, isSuccess }) {
  if (isLoading) {
    return (
      <div className="stats-grid">
        {Array(4)
          .fill(0)
          .map((_, i) => (
            <div key={i} className="stat-card animate-pulse">
              <div className="h-6 w-16 bg-gray-200 rounded mb-2"></div>
              <div className="h-4 w-24 bg-gray-200 rounded"></div>
            </div>
          ))}
      </div>
    );
  }

  if (!isSuccess || !stats) {
    stats = {
      totalAppointmentsToday: 0,
      totalAppointmentsChangePercent: 0,
      followUpAppointments: 0,
      followUpChangePercent: 0,
      cancelledAppointments: 0,
      cancelledChangePercent: 0,
      rescheduledAppointments: 0,
      rescheduledChangePercent: 0,
    };
  }

  const statCards = [
    {
      title: "Today's Appointments",
      value: stats.totalAppointmentsToday ?? 0,
      change: `${stats.totalAppointmentsChangePercent ?? 0}% from yesterday`,
      color: "#10b981",
      changeColor: (stats.totalAppointmentsChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      circleColor: "rgba(16, 185, 129, 0.15)",
      icon: <i className="fa-solid fa-calendar-check"></i>,
    },
    {
      title: "Follow-Up Appointments",
      value: stats.followUpAppointments ?? 0,
      change: `${stats.followUpChangePercent ?? 0}% from yesterday`,
      color: "#3b82f6",
      changeColor: (stats.followUpChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      circleColor: "rgba(59, 130, 246, 0.15)",
      icon: <i className="fa-solid fa-user-check"></i>,
    },
    {
      title: "Cancelled Appointments",
      value: stats.cancelledAppointments ?? 0,
      change: `${stats.cancelledChangePercent ?? 0}% from yesterday`,
      color: "#ef4444",
      changeColor: (stats.cancelledChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      circleColor: "rgba(239, 68, 68, 0.15)",
      icon: <i className="fa-solid fa-xmark-circle"></i>,
    },
    {
      title: "Rescheduled Appointments",
      value: stats.rescheduledAppointments ?? 0,
      change: `${stats.rescheduledChangePercent ?? 0}% vs usual`,
      color: "#f59e0b",
      changeColor: (stats.rescheduledChangePercent ?? 0) >= 0 ? "#10b981" : "#ef4444",
      circleColor: "rgba(245, 158, 11, 0.15)",
      icon: <i className="fa-solid fa-arrows-rotate"></i>,
    },
  ];

  return (
    <div className="stats-grid">
      {statCards.map((stat, index) => (
        <div key={index} className="stat-card">
          <span className="circle-before" style={{ background: stat.circleColor }}></span>
          <span className="circle-after" style={{ background: stat.circleColor }}></span>
          <div className="stat-content">
            <h3>{stat.value}</h3>
            <p className="stat-title">{stat.title}</p>
            <p className="stat-change" style={{ color: stat.changeColor }}>
              {stat.change}
            </p>
          </div>
          <div style={{ fontSize: "26px", color: stat.color }}>{stat.icon}</div>
        </div>
      ))}
    </div>
  );
}

export default DocStats;
